<template>
	<div class="flex flex-col">
		<div class="grow text-center">
			<h2>{{ t("auth.accountActivation") }}</h2>
			<p>{{ t("auth.accountActivationCaption") }}</p>
		</div>
		<div class="mt-4">
			<UpdatePasswordForm
				inputClass="bg-current/20 text-primary-content w-full"
				showEula
				:label="$t('users.activateAccount')"
				@update:password="activateAccount"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useApi } from "@soft-db/monitoring-api-client";
import { useRouter } from "vue-router";
import UpdatePasswordForm from "./UpdatePasswordForm.vue";

const { t } = useI18n();

const props = defineProps<{
	code: string;
}>();

const router = useRouter();

const auth = useApi().auth();

async function activateAccount(password: string) {
	const success = await auth.activateAccount(props.code, password);
	if (success) {
		router.push({ name: "auth-login" });
	}
}
</script>
